<template>
  <div class="stock__header" v-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true">
    <backlink/>
    <div class="stock__header-title-container">
      <img src="/static/img/pictos/stockcamion.svg" class="">
      <span>Mon stock</span>
    </div>
    <input name="" value="" class="search__field" placeholder="Recherche" @keyup="searchFilter()">
  </div>
</template>

<script>

  export default {
    name: "StockHeader",
    data() {
      return {
      }
    },
    components: {

    },
    computed: {

    },
    methods: {
      searchFilter(){
        let searched = event.target.value;
        this.$emit('searchStock', searched);
      },
    },
    mounted() {

    }
  };
</script>

<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  .stock__header{ background-color: $vertjaune; padding: 65px 20px 20px 20px;
    .backlink{ margin-bottom: 5px; }
    .stock__header-title-container{ display: flex; align-items: flex-end; }
    img{ width: 100px; margin-left: 35px; }
    span{ color: white; font-family: 'ClanFFBlack'; font-size: 25px; margin-top: 25px; text-transform: uppercase; flex: 1; text-align: right;}
    .search__field{ background-color: transparent; border: 1px solid $color1; font-family: 'ClanPro'; font-size: 14px; color: $color1; width: 100%; outline: none; height: 45px; line-height: 45px; padding: 0 20px; border-radius: 24px; margin-top: 20px; margin-top: 30px; }
  }

</style>



// WEBPACK FOOTER //
// src/components/Stock/StockHeader.vue